import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import * as Styles from './IconButton.styles';

export type Variant = 'neutral' | 'primary';

type IconButtonType = {
  icon: typeof MoreHorizIcon;
  variantStyle?: Variant;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function IconButton({
  icon: Icon,
  variantStyle = 'neutral',
  ...props
}: IconButtonType): JSX.Element {
  return (
    <Styles.IconButton $variant={variantStyle} {...props}>
      <Icon />
    </Styles.IconButton>
  );
}
